import { render, staticRenderFns } from "./reviewRejected.vue?vue&type=template&id=7a997366&scoped=true"
import script from "./reviewRejected.vue?vue&type=script&lang=js"
export * from "./reviewRejected.vue?vue&type=script&lang=js"
import style0 from "./reviewRejected.vue?vue&type=style&index=0&id=7a997366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a997366",
  null
  
)

export default component.exports